/**
 * Created by Udara Prabath
 * Date: 11/10/2020
 * Using: IntelliJ IDEA
 */
import React from 'react';
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import './Video.scss'
import 'videojs-youtube';

export default class VideoPlayer extends React.Component {
    componentDidMount() {
        if (this.props.video !== undefined && this.props.video !== null){
            const videoJsOptions = {
                autoplay: false,
                controls: true,
                errorDisplay: false,
                sources: [{
                    src: this.props.video,
                    type: 'video/youtube'
                }]
            }

            this.player = videojs(this.videoNode, videoJsOptions, function onPlayerReady() {
                console.log('onPlayerReady', this)
            });
        }
    }

    // destroy player on unmount
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose()
        }
    }

    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856
    render() {

        return (
            <div data-vjs-player>
                <video
                    ref={ node => this.videoNode = node }
                    className={"video-js videoPlayer3 mb-3"}>

                </video>
            </div>

        )
    }
}
